var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicSelectInline", {
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.careerLevel,
      "initial-show-all": "",
      "label-type": "job-profile"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }